import fp from "lodash/fp";
import React from "react";
import { connect } from "react-redux";
import { compose, withStateHandlers } from "recompose";
import { Icon } from ".";
import { noCapMap } from "../../utils";
import Loading from "../pages/loading";

const SortingArrow = ({ field, sorting }) => {
  if (sorting[field] === "asc") {
    return <Icon icon="arrow-up-medium" />;
  } else if (sorting[field] === "desc") {
    return <Icon icon="arrow-down-medium" />;
  } else {
    return (
      <span>
        <Icon icon="arrow-down-medium" />
        <Icon icon="arrow-up-medium" />
      </span>
    );
  }
};

const SortableTable = ({
  rows,
  columns,
  sort,
  sorting,
  sortBy,
  isFetching,
  isFetchingAll,
  className,
  unclickable,
  emptyData
}) => (
    <table className={className}>
      <thead>
        <tr>
          {
            fp.map(column =>
              <th
                key={column.name}
                className={column.className() + ((column.sortable && !unclickable) ? "" : " unclickable")}
                onClick={(column.sortable && !unclickable) ? e => (sortBy && sort(column.name, sorting)) : undefined}
              >
                {column.display()}
                {((column.display() !== '') && (column.sortable) && sortBy) ? '\u00A0' : ''}
                {((column.display() !== '') && (column.sortable) && sortBy) ? <SortingArrow field={column.name} sorting={sorting} /> : null}
              </th>
            )(columns)}
        </tr>
      </thead>
      {
        isFetchingAll ?
          <tbody>
            <tr>
              <td colSpan={7} className="text-center">
                <Loading />
              </td>
            </tr>
          </tbody> :
          <tbody>
            {
              rows.length ? (
                noCapMap((row, rid) => (
                  <tr key={rid} className={row.className} onClick={row.handler}>
                    {
                      fp.map(column =>
                        <td
                          key={`${rid}-${column.name}`}
                          className={column.name === 'riskRating' ? column.className(row[column.name]) : column.className()}
                        >
                          {row[column.name]}
                        </td>
                      )(columns)
                    }
                  </tr>
                ))(rows)
              ) : null
            }
            {
              !rows.length && !isFetching ? (
                <tr>
                  <td colSpan={columns.length}>{emptyData ? emptyData : 'No Data Entry'}</td>
                </tr>
              ) : null
            }
            {
              isFetching ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    <Loading />
                  </td>
                </tr>
              ) : null
            }
          </tbody>
      }
    </table>
  );

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      sorting: {}
    },
    {
      sort: (prevState, { sortBy }) => (field, sorting) => {
        let nextSortOrder = null;
        if (!sorting[field]) {
          nextSortOrder = "asc";
        }

        if (sorting[field] === "asc") {
          nextSortOrder = "desc";
        }

        if (sorting[field] === "desc") {
          nextSortOrder = undefined;
        }

        sortBy(field, nextSortOrder);

        return {
          sorting: { [field]: nextSortOrder }
        };
      }
    }
  )
)(SortableTable);



// WEBPACK FOOTER //
// ./src/containers/components/sortable-table.js